export interface ThemePreset {
  name: string;
  description: string;
  /** Swatch shown in the 5-color picker */
  swatch: string;
  sidebarColor: string;
  tableColor: string;
  formHeaderColor: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
}

/**
 * Five brand color presets — Settings → Theme.
 * Replaces older Glass / Dark / Google templates.
 */
export const THEME_PRESETS: ThemePreset[] = [
  {
    name: 'Purple',
    description: 'Tripiigo brand',
    swatch: '#6221d6',
    sidebarColor: '#0a0a0a',
    tableColor: '#6221d6',
    formHeaderColor: '#6221d6',
    primaryColor: '#6221d6',
    secondaryColor: '#64748b',
    accentColor: '#8b5cf6',
  },
  {
    name: 'Blue',
    description: 'Corporate blue',
    swatch: '#2563eb',
    sidebarColor: '#0f172a',
    tableColor: '#1d4ed8',
    formHeaderColor: '#2563eb',
    primaryColor: '#2563eb',
    secondaryColor: '#64748b',
    accentColor: '#60a5fa',
  },
  {
    name: 'Teal',
    description: 'Fresh teal',
    swatch: '#0d9488',
    sidebarColor: '#042f2e',
    tableColor: '#0f766e',
    formHeaderColor: '#0d9488',
    primaryColor: '#0d9488',
    secondaryColor: '#64748b',
    accentColor: '#2dd4bf',
  },
  {
    name: 'Orange',
    description: 'Warm accent',
    swatch: '#ea580c',
    sidebarColor: '#1c1917',
    tableColor: '#c2410c',
    formHeaderColor: '#ea580c',
    primaryColor: '#ea580c',
    secondaryColor: '#78716c',
    accentColor: '#fb923c',
  },
  {
    name: 'Rose',
    description: 'Soft rose',
    swatch: '#e11d48',
    sidebarColor: '#1c1917',
    tableColor: '#be123c',
    formHeaderColor: '#e11d48',
    primaryColor: '#e11d48',
    secondaryColor: '#78716c',
    accentColor: '#fb7185',
  },
];
